import type { Feature, WorkProduct } from "../types";

export interface WorkProductEditorScope {
    featureId?: number;
    userStoryId?: string;
}

const normalizeLevel = (value: unknown): string =>
    String(value || "").replace(/[_\s-]/g, "").toUpperCase();

const validFeatureId = (value: unknown): number | undefined => {
    const numeric = Number(value);
    return Number.isSafeInteger(numeric) && numeric > 0 ? numeric : undefined;
};

/**
 * Resolves the hierarchy scope used by the IDE and collaboration room.
 * An explicit Product level must not inherit the Feature that remains selected
 * in Feature Studio after the user opens a Feature or Story document.
 */
export function resolveWorkProductEditorScope(
    workProduct: WorkProduct | null,
    selectedFeature?: Feature | null
): WorkProductEditorScope {
    if (!workProduct) return {};

    const level = normalizeLevel(workProduct.level);
    if (level === "PRODUCT") return {};

    const featureId = validFeatureId(
        workProduct.feature_id ?? selectedFeature?.id ?? (selectedFeature as any)?.featureid
    );
    const userStoryId = workProduct.user_story_id ? String(workProduct.user_story_id) : undefined;

    if (level === "FEATURE") return { featureId };
    if (level === "USERSTORY") return { featureId, userStoryId };

    // Legacy rows may not declare a level. Preserve their existing contextual
    // fallback while preferring scope stamped onto the selected work product.
    return { featureId, userStoryId };
}
